import React, { useEffect, useState } from 'react';
import { Auth, API, graphqlOperation } from 'aws-amplify';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
//import { listCampaigns } from '../../../../graphql/queries'

import {
  DetailContainer,
  CardLogo,
  MainDetail,
  InvestDetail,
  CampaignInfo,
  CardStatus,
  GeneralInfo,
  InterestInfo
} from './opportunitiesDetail.styles';
import { useDispatch, useSelector } from 'react-redux';
import InvestSimulator from '../investSimulator/investSimulator';
import { fetchPersonalInformation } from 'src/store/Profile/profile.slice';
import axios from 'axios';
import { environment, url } from 'src/environments';

const OpportunitiesDetail = (props) => {
  const defaultImage = `${process.env.REACT_APP_BUCKET_FINSPHERA}/image.png`;
  const location = useLocation();
  const item = location.state?.detail || null;
  const dataCompany = item?.applicant?.companyInformation;
  const [profileImage, setProfileImage] = useState('');
  const user = useSelector((state) => state.user.currentUser);
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    if (user.id) {
      dispatch(fetchPersonalInformation(user.id));
    }
  }, [user.id, dispatch]);

  useEffect(() => {
    fetchImage().then(setProfileImage);
  }, []);
  const fetchImage = async () => {
    const body = {
      Key: `${user.id}/media/profileImage.jpg`
    };
    try {
      const image = await axios.post(
        `${url}/${environment}/admin/documents/get-presignedurl`,
        body
      );
      setProfileImage(image);
      return image;
    } catch (err) {
      console.error(err);
      return defaultImage;
    }
  };
  const percentageFinanced =
    item?.collectedAmount >= 0
      ? Math.round((item?.collectedAmount / item?.montoSolicitado) * 100)
      : 0;

  function formatCurrency(amount) {
    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN'
    }).format(amount);
  }
  return (
    <DetailContainer>
      <MainDetail>
        <CardLogo>
          <img src={profileImage} alt="CompanyLogo" />
        </CardLogo>
        <InvestDetail>
          <div>
            <h2>{dataCompany?.companyName ? dataCompany?.companyName : '-'}</h2>
            <p>Monto a financiar</p>
            <h2>{formatCurrency(item?.montoSolicitado ? item?.montoSolicitado : '-')}</h2>
          </div>
          <div>
            <CardStatus percentage={percentageFinanced}>
              <h3>% financiado</h3>
              <div>
                <div></div>
              </div>
            </CardStatus>
            <h3>Monto hasta ahora:</h3>
            <p>{item?.collectedAmount === -1 ? '0.00' : formatCurrency(item?.collectedAmount)}</p>
            <div>
              <div></div>
            </div>
          </div>
        </InvestDetail>
        <Link to="/inversionista/dashboard/oportunidades">Regresar</Link>
      </MainDetail>
      <CampaignInfo>
        <GeneralInfo>
          <h2>ID Solicitud: </h2>
          <p>{item?.id ? item.id : '-'}</p>
          <h2>Destino del crédito: </h2>
          <p>{item?.destinoCredito ? item?.destinoCredito : '-'}</p>
          <h2>Plazo: </h2>
          <p>{item?.plazoCredito ? item?.plazoCredito : '-'}</p>
          <h2>Fuente de ingresos para pago: </h2>
          <p>{item?.fuentePago ? item?.fuentePago : '-'}</p>
        </GeneralInfo>
        <GeneralInfo>
          <h3>Actividad económica:</h3>
          <p>{dataCompany?.generalActivity ? dataCompany?.generalActivity : '-'}</p>
          <h3>Actividad específica:</h3>
          <p>{dataCompany?.specificActivity ? dataCompany?.specificActivity : '-'}</p>
          <h3>Sector de negocio:</h3>
          <p>{dataCompany?.businessSector ? dataCompany?.businessSector : '-'}</p>
          <h3>Página web:</h3>
          <p>{dataCompany?.webSite ? dataCompany?.webSite : '-'}</p>
          <h3>Correo de contacto:</h3>
          <p>{dataCompany?.email ? dataCompany?.email : '-'}</p>
        </GeneralInfo>
        <InterestInfo>
          <h2>Tasa de interés adicional: </h2>
          <p>{Number(item?.tasaInteresAdicionalPorcentaje * 100).toFixed(2)} %</p>
          <h2>Tasa de interés del crédito: </h2>
          <p>{Number(item?.tasaCreditoPorcentaje * 100).toFixed(2)} %</p>
          <h2>Interes del crédito en pesos: </h2>
          <p>{formatCurrency(item?.interesCreditoPesos)}</p>
          <h2>IVA del interés del crédito en pesos: </h2>
          <p>{formatCurrency(item?.IVAinteresCreditoPesos)}</p>
          <h2>Interés del crédito en pesos + IVA: </h2>
          <p>{formatCurrency(item?.interesesCreditoPesosConIVA)}</p>
        </InterestInfo>
        <InterestInfo>
          <h2>Comisión del crédito:</h2>
          <p>{formatCurrency(item?.comisionCreditoPesos)}</p>
          <h2>IVA de la comisión del crédito: </h2>
          <p>{formatCurrency(item?.IVAcomisionCreditoPesos)}</p>
          <h2>Comisión del crédito + IVA: </h2>
          <p>{formatCurrency(item?.comisionCreditoPesosConIVA)}</p>
          {/* <h2>% inversión de Finsphera en campaña: </h2>
          <p>{Number(item.inversionFinspheraCampaniaPorcentaje).toFixed(2) * 100} %</p> */}
          <h2>Monto inversión de Finsphera en campaña: </h2>
          <p>{formatCurrency(item?.inversionFinspheraCampaniaPesos)}</p>
        </InterestInfo>
      </CampaignInfo>
      <InvestSimulator />
    </DetailContainer>
  );
};

export default OpportunitiesDetail;
